import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { AccessRoleDeserializer } from "./access-role-deserializer.service";
import { ApiUpsertAccessRoleRequest } from "../apiClient/models";
import { OrganizationsClient } from "../apiClient/services";
import { AccessRoleDetails, AccessRoleOverview } from "../domain/access-role";
import { RanExpenseAccess } from "../domain/extra-service";

@Injectable({
  providedIn: "root",
})
export class AccessRoleService {
  constructor(
    private readonly organizationsClient: OrganizationsClient,
    private readonly deserializer: AccessRoleDeserializer,
  ) {}

  public getAccessRoles$(orgId: number): Observable<AccessRoleOverview[]> {
    return this.organizationsClient
      .getAccessRoles({ orgId })
      .pipe(map((roles) => roles.map((r) => this.deserializer.fromApiOverview(r))));
  }

  public getAccessRole$(orgId: number, accessRoleId: number): Observable<AccessRoleDetails> {
    return this.organizationsClient
      .getAccessRole({ orgId, accessRoleId })
      .pipe(map((r) => this.deserializer.fromApiDetails(r)));
  }

  public createAccessRole$(orgId: number, body: ApiUpsertAccessRoleRequest): Observable<AccessRoleDetails> {
    return this.organizationsClient
      .createAccessRole({ orgId, body })
      .pipe(map((r) => this.deserializer.fromApiDetails(r)));
  }

  public updateAccessRole$(
    orgId: number,
    accessRoleId: number,
    body: ApiUpsertAccessRoleRequest,
  ): Observable<AccessRoleDetails> {
    return this.organizationsClient
      .updateAccessRole({ orgId, accessRoleId, body })
      .pipe(map((r) => this.deserializer.fromApiDetails(r)));
  }

  public deleteAccessRole$(orgId: number, accessRoleId: number): Observable<void> {
    return this.organizationsClient.deleteAccessRole({ orgId, accessRoleId });
  }

  public setRanExpenseAccess$(orgId: number, accessRoleId: number, access: RanExpenseAccess): Observable<void> {
    return this.organizationsClient.setAccessRoleRanExpenseAccess({ orgId, accessRoleId, body: { access } });
  }

  public getUserAccessRole$(orgId: number, userId: number): Observable<AccessRoleDetails> {
    return this.organizationsClient
      .getUserAccessRole({ orgId, userId })
      .pipe(map((r) => this.deserializer.fromApiDetails(r)));
  }
}
